import React, { useRef, useEffect } from "react";
import { gsap } from "gsap";

function Hero(props) {
  const heroImage = useRef();
  const heroTitle = useRef();
  const navBg = useRef();
  const openCont = useRef();
  const closeCont = useRef();
  const whiteLogoHeader = useRef();
  const blackLogoHeader = useRef();
  const title1 = useRef();
  const title2 = useRef();
  const title3 = useRef();
  const socialHeader = useRef();
  const phoneHeader = useRef();
  const emailHeader = useRef();
  const tl = useRef();

  const linkCopy = "text-left m-auto xs:text-3xl hover:text-[#cccccc] sm:text-3xl md:text-3xl text-[#141833] md:w-[700px] lg:text-4xl lg:!leading-[3rem] lg:w-[800px] xl:text-4xl xl:!leading-[4rem] xl:w-[1200px] font-ppNeue";

  const slideIn = () => {
    tl.current = gsap
      .timeline()
      .to(openCont.current, { duration: 0.25, autoAlpha: 0 }, "<")
      .to(navBg.current, { duration: 0.5, left: "0" }, "<")
      .to(blackLogoHeader.current, { duration: 0.25, autoAlpha: 1 }, "<0.5")
      .to(title1.current, { duration: 0.75, autoAlpha: 1, y: 0, ease: "sine.out" }, "<0.25")
      .to(title2.current, { duration: 0.75, autoAlpha: 1, y: 0, ease: "sine.out" }, "<0.25")
      .to(title3.current, { duration: 0.75, autoAlpha: 1, y: 0, ease: "sine.out" }, "<0.25")
      .to(socialHeader.current, { duration: 0.5, autoAlpha: 1, y: 0, ease: "sine.out" }, "<0.1")
      .to(phoneHeader.current, { duration: 0.5, autoAlpha: 1, y: 0, ease: "sine.out" }, "<0.1")
      .to(emailHeader.current, { duration: 0.5, autoAlpha: 1, y: 0, ease: "sine.out" }, "<0.1")
      .to(closeCont.current, { duration: 0.5, autoAlpha: 1, y: 0, ease: "sine.out" }, "<0.5");
  };

  const slideOut = () => {
    gsap.set([closeCont.current, blackLogoHeader.current], { autoAlpha: 0 });

    gsap.set([title1.current, title2.current, title3.current, socialHeader.current, phoneHeader.current, emailHeader.current], {
      autoAlpha: 0,
      y: 50,
    });

    tl.current = gsap
      .timeline()

      .to(navBg.current, { duration: 0.5, left: "-100%" }, "<0.15")
      .to(openCont.current, { duration: 0.15, autoAlpha: 1, delay: 0.15 }, "<1");
  };

  useEffect(() => {
    gsap.delayedCall(1, function () {
      gsap.to(heroImage.current, { alpha: 1, duration: 0.5 });
      gsap.to(heroTitle.current, { y: 0, autoAlpha: 1, delay: 0.5 });
    });

    gsap.set(heroTitle.current, { y: 50, autoAlpha: 0 });

    gsap.set([closeCont.current, blackLogoHeader.current], { autoAlpha: 0 });
    gsap.set([title1.current, title2.current, title3.current, socialHeader.current, phoneHeader.current, emailHeader.current], {
      autoAlpha: 0,
      y: 50,
    });
  });

  return (
    <container className="">
      <section
        ref={heroImage}
        style={{
          backgroundImage: `url("../images/` + props.heroImg + `.jpg")`,
        }}
        alt="hero"
        className="bg-no-repeat bg-center bg-cover relative xs:h-[75vh] md:h-screen w-full xs:px-6 sm:px-12 lg:px-36 pb-32 pt-12 justify-center top-0 opacity-0"
      >
        <div className="sm:flex-row flex">
          <article className="xs:w-full sm:w-1/5">
            <a href="/">
              <img ref={whiteLogoHeader} alt="logo" className="xs:w-[125px] sm:w-[219px] max-w-none" src="../images/hero-logo.png"></img>
            </a>
          </article>
          <article className="xs:w-11/12 sm:w-4/5 text-right text-[#EDB6A2]">
            <div ref={openCont} className="w-[100px] h-[50px] float-right relative xs:top-[25px] sm:top-[60px]">
              <button href="#" onClick={slideIn} aria-label="Open Menu">
                <div className="w-[50px] h-[2px] bg-white"></div>
                <div className="w-[50px] h-[2px] bg-white mt-1"></div>
                <div className="w-[50px] h-[2px] bg-white mt-1"></div>
              </button>
            </div>
          </article>
        </div>
        <div className="grid place-items-center h-screen">
          <h1 ref={heroTitle} className="font-gothLight text-white xs:text-2xl sm:text-3xl md:text-4xl top-[-10%] relative text-center">
            {props.title}
          </h1>
        </div>
      </section>
      <section ref={navBg} className="bg-no-repeat bg-center bg-cover xs:h-[75vh] md:h-screen w-full xs:px-6 sm:px-12 lg:px-36 pb-32 pt-12 absolute left-[-100%] top-0 bg-white">
        <div className="flex">
          <article className="xs:w-full sm:w-1/5">
            <a href="/">
              <img ref={blackLogoHeader} alt="logo" className="xs:w-[125px] sm:w-[219px] max-w-none" src="../images/hero-logo-dark.png"></img>
            </a>
          </article>
          <article className="w-4/5 text-right text-[#EDB6A2]">
            <div ref={closeCont} className="w-[100px] h-[50px] float-right relative xs:top-[22px] sm:top-[54px] xs:left-[10px]">
              <button href="#" onClick={slideOut} aria-label="Open Menu">
                <img alt="close Icon" className="w-[75px] h-[25px]" src="../images/close-line-icon.svg"></img>
              </button>
            </div>
          </article>
        </div>
        <article className="w-full">
          <nav className="xs:pt-16 sm:pt-24 text-left">
            <a href="/properties">
              <button ref={title1} className={linkCopy}>
                Projects
              </button>
            </a>
            <br></br>
            <a href="/about">
              <button ref={title2} className={linkCopy}>
                About
              </button>
            </a>
            <br></br>
            <a href="/design">
              <button ref={title3} className={linkCopy}>
                Design
              </button>
            </a>
            <div className="w-full relative xs:pt-16 sm:pt-16 text-left text-[#141833]">
              <img ref={socialHeader} className="inline" alt="logo" src="../images/insta-logo-header.png"></img>
              <p ref={phoneHeader} className="pt-10">
                +44 (0) 1279 881605
              </p>
              <p ref={emailHeader}>hello@chaldean-prime.co.uk</p>
            </div>
          </nav>
        </article>
      </section>
    </container>
  );
}

export default Hero;
